module.exports = __webpack_public_path__ + "static/media/KegIcon.3fe9ddb7.svg";